import AppButton from "@/components/AppButton.vue";
import Card from "@/components/Card.vue";
import ContactChoiceModal from "@/components/ContactChoiceModal.vue";
import HeaderModality from "@/components/HeaderModality.vue";
import ImageHeader from "@/components/ImageHeader.vue";
import InputText from "@/components/InputText.vue";
import ListDefault from "@/components/ListDefault.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import Option from "@/components/Option.vue";
import OptionField from "@/components/OptionField.vue";
import OrderItem from "@/components/OrderItemNew.vue";
import SelectField from "@/components/SelectField.vue";
import TextLink from "@/components/TextLink.vue";
import GoogleTagManagerService from "@/services/google-tag-manager.service";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import moment from "moment";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import QRCode from "qrcodejs2";
import { Component, Vue } from "vue-property-decorator";

declare let M: any;
declare let $: any;
declare const fbq: any;
@Component({
  components: {
    HeaderColor,
    ImageHeader,
    Card,
    InputText,
    AppButton,
    SelectField,
    OptionField,
    ModalCodigo,
    HeaderModality,
    TextLink,
    Option,
    ListDefault,
    OrderItem,
    ContactChoiceModal,
  },
})
export default class ExtratoPedido extends Vue {
  orderData: any = JSON.parse(sessionStorage.getItem("CURRENT_ORDER") || "{}");
  resultadoOrderCancel = false;
  msgResultadoOrderCancel: any = "";
  storeContact: any = {};
  switch = true;
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.goBack,
  };
  maxDeliveryTime: number | null = null;
  minDeliveryTime: number | null = null;
  createdDate?: any;
  hasPixel: any = JSON.parse(sessionStorage.getItem("hasPixel") || "false");
  items: any = [];
  subTotal = 0;
  orderHistoryStatus: any = null;
  statusColorOrder = "";
  borderColorOrder = "";
  showModal = false;
  showModalCancelOrder = false;
  modalMessage = "";
  modalMessageTop = "";
  currentOrder: any = undefined;
  withinRatingPeriod = false;
  showContactModal = false;
  responseCancelOrder = false;

  get getHistoryStatusString(): string {
    if (this.orderHistoryStatus.length === 0) return "Nenhum pedido disponível";

    const lastStatus =
      this.orderHistoryStatus[this.orderHistoryStatus.length - 1];
    const status = lastStatus.status;

    // Mapa de cores suaves para os status
    const statusColors: { [key: string]: { bg: string; border: string } } = {
      "A entregar": { bg: "#E3F2FD", border: "#BBDEFB" },
      avaliando: { bg: "#F3E5F5", border: "#E1BEE7" },
      Cancelado: { bg: "#FFEBEE", border: "#FFCDD2" },
      Concluido: { bg: "#E8F5E9", border: "#C8E6C9" },
      "Confirmar Pedido": { bg: "#FFFDE7", border: "#FFF9C4" },
      "Em andamento": { bg: "#E3F2FD", border: "#BBDEFB" },
      "Em confirmação": { bg: "#E0F7FA", border: "#B2EBF2" },
      "Em entrega": { bg: "#E1F5FE", border: "#B3E5FC" },
      "Em preparação": { bg: "#E8F5E9", border: "#C8E6C9" },
      "Em preparo": { bg: "#E8F5E9", border: "#C8E6C9" },
      "Em produção": { bg: "#F1F8E9", border: "#DCEDC8" },
      "Em rota de entrega": { bg: "#E3F2FD", border: "#BBDEFB" },
      "Em Separação": { bg: "#FFF3E0", border: "#FFE0B2" },
      "Em transito": { bg: "#E1F5FE", border: "#B3E5FC" },
      Entregue: { bg: "#E8F5E9", border: "#C8E6C9" },
      Enviado: { bg: "#E1F5FE", border: "#B3E5FC" },
      Fechado: { bg: "#ECEFF1", border: "#CFD8DC" },
      Finalizado: { bg: "#E8F5E9", border: "#C8E6C9" },
      Novo: { bg: "#FCE4EC", border: "#F8BBD0" },
      "Novo Pedido": { bg: "#FCE4EC", border: "#F8BBD0" },
      "Pedido em Produção": { bg: "#F1F8E9", border: "#DCEDC8" },
      "Pedido Novo": { bg: "#FCE4EC", border: "#F8BBD0" },
      "Pedido Pendente": { bg: "#FFFDE7", border: "#FFF9C4" },
      "Pedido Pronto": { bg: "#E8F5E9", border: "#C8E6C9" },
      "Pedido Recebido": { bg: "#E3F2FD", border: "#BBDEFB" },
      "Preparando pedido": { bg: "#FFF3E0", border: "#FFE0B2" },
      Produzindo: { bg: "#F1F8E9", border: "#DCEDC8" },
      Pronto: { bg: "#E8F5E9", border: "#C8E6C9" },
      "Pronto para entrega": { bg: "#E1F5FE", border: "#B3E5FC" },
      Recebido: { bg: "#E3F2FD", border: "#BBDEFB" },
      "Sair para entrega": { bg: "#E1F5FE", border: "#B3E5FC" },
      "Saiu para entrega": { bg: "#E1F5FE", border: "#B3E5FC" },
      Separado: { bg: "#FFF3E0", border: "#FFE0B2" },
    };

    // Define as cores do status ou usa um padrão se não encontrado
    const colors = statusColors[status] || { bg: "#F5F5F5", border: "#E0E0E0" };
    this.statusColorOrder = colors.bg;
    this.borderColorOrder = colors.border;

    // Formata a data
    const dateTime = new Date(lastStatus.createDate.date);
    const hours = dateTime.getHours().toString().padStart(2, "0");
    const minutes = dateTime.getMinutes().toString().padStart(2, "0");

    return `Pedido ${status} às ${hours}:${minutes}`;
  }

  async mounted() {
    if (this.hasPixel) {
      fbq("trackCustom", "viewOrderExtrack");
    }
    Util.setBackButtonBehavior(this.goBack);
    await this.getOrderData();
    this.getHistoryStatusOrder();
    this.getDeliveryTime();
  }

  goBack() {
    this.$router.go(-1);
  }

  switchActive() {
    this.switch = !this.switch;
    if (this.switch) {
      $("#accordionContent").addClass("is-closed");
      $("#accordionIconUp").addClass("is-closed");
      $("#accordionIconDown").removeClass("is-closed");
    } else {
      $("#accordionContent").removeClass("is-closed");
      $("#accordionIconUp").removeClass("is-closed");
      $("#accordionIconDown").addClass("is-closed");
    }
  }

  openSuportStore() {
    this.showContactModal = true;
  }

  montarQrCodeUserId(key: any) {
    setTimeout(() => {
      try {
        const el: any = document.getElementById("qrcode") || {};
        if (el) {
          el.innerHTML = "";

          new QRCode(document.getElementById("qrcode"), key);
        }
      } catch (e) {
        console.log(e);
      }
    }, 500);
  }

  formatDateTimeScheduled(stringDate: string): string {
    const [date, ...schedulesArray] = stringDate.split(" ");
    const schedules = schedulesArray.join(" ");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${day}/${month}/${year}`;
    const result = `${dateFormatted} de ${schedules}`;

    return result;
  }

  formatDateTime(stringDate: string, momentFormat = false) {
    const momentDate: any = moment(stringDate);
    let actualDateTime;
    let brasiliaUTC = 180;
    if (moment().isDST()) {
      brasiliaUTC = 120;
    }
    if (moment().utcOffset() === brasiliaUTC) {
      actualDateTime = momentDate;
    } else {
      const offsset = brasiliaUTC - -moment(stringDate).utcOffset();

      if (offsset < -1) {
        actualDateTime = moment(stringDate).subtract(offsset * -1, "minutes");
      } else {
        actualDateTime = moment(stringDate).add(offsset, "minutes");
      }
    }

    if (momentFormat)
      return actualDateTime.lang("pt-br").format("YYYY-MM-DD HH:mm:ss");

    return actualDateTime.lang("pt-br").format("DD/MM/YYYY [às] HH:mm");
  }

  getOrderData() {
    return new Promise((resolve) => {
      try {
        const self = this;
        const req = new Request();
        req.body = {
          NRORG: sessionStorage.getItem("NRORG"),
          USER_ID: sessionStorage.getItem("USER_ID"),
          TOKEN: sessionStorage.getItem("TOKEN"),
          ORDER_ID: sessionStorage.getItem("ORDER_ID"),
        };
        req.route = "getOrderData";
        req.callbackSuccess = (response: any) => {
          self.orderData = response.order;

          if (response.order.customerAddress != null) {
            sessionStorage.setItem(
              "LATITUDE",
              response.order.customerAddress.LATITUDE
            );
            sessionStorage.setItem(
              "LONGITUDE",
              response.order.customerAddress.LONGITUDE
            );
          }
          this.storeContact = response.order.storeContact;
          this.createdDate = response.order.createDate;
          if (response.order.qr) this.montarQrCodeUserId(response.order.qr);
          this.items = response.order.items;
          this.subTotal = response.order.subtotal;

          if (
            self.orderData &&
            self.orderData.createDate &&
            self.orderData.createDate.date
          ) {
            const orderDate = new Date(self.orderData.createDate.date);
            const now = new Date();
            this.withinRatingPeriod =
              now.getTime() - orderDate.getTime() <= 7 * 24 * 60 * 60 * 1000;
          } else {
            this.withinRatingPeriod = false;
          }

          resolve(true);
        };
        req.callbackError = function (error: any) {
          console.log(error);
          resolve(true);
        };
        req.blockTouchEvents = false;
        req.send();
      } catch (e) {
        console.log(e);
      }
    });
  }

  getHistoryStatusOrder() {
    const self = this;
    const req = new Request();
    req.route = "getHistoryStatusOrder";
    req.body = {
      USER_ID: sessionStorage.getItem("USER_ID"),
      TOKEN: sessionStorage.getItem("TOKEN"),
      ORDER_ID: sessionStorage.getItem("ORDER_ID"),
      NRORG: sessionStorage.getItem("NRORG"),
    };
    req.callbackSuccess = function (response: any) {
      self.orderHistoryStatus = response.orderHistory.sort(compare);

      function compare(a: any, b: any) {
        if (a.id < b.id) return 1;
        if (a.id > b.id) return -1;
        return 0;
      }

      console.log(self.orderHistoryStatus);
    };
    req.callbackError = function (error: any) {
      console.log(error);
    };
    req.send();
  }

  cancelOrder(orderId: number) {
    this.showModalCancelOrder = false;
    const self = this;
    const req = new Request();
    req.body = {
      ORDER_ID: orderId,
      TOKEN: sessionStorage.getItem("TOKEN"),
      USER_ID: sessionStorage.getItem("USER_ID"),
      MESSAGE_CANCELLATION: "Cancelado pelo Usuário",
      CANCELLATION_ID: 2,
      SCREEN_MOMENT: "ExtratoPedido",
    };
    req.route = "cancelOrder";
    req.callbackSuccess = function () {
      self.msgResultadoOrderCancel =
        "Seu pedido número " + orderId + " foi cancelado!";
      self.resultadoOrderCancel = true;
      self.responseCancelOrder = true;
      //self.goBack();
    };
    req.callbackError = function () {
      self.msgResultadoOrderCancel =
        "Ocorreu um erro para cancelar seu pedido de número " +
        orderId +
        ", tente novamente! Se persistir o erro entre em contato com a loja.";
      self.resultadoOrderCancel = true;
      self.responseCancelOrder = false;
    };
    req.showLoader = true;
    req.send();
  }

  getDeliveryTime() {
    const orders = JSON.parse(sessionStorage.getItem("ORDERS") || "[]");

    const order = orders.filter((order: any) =>
      order.id.toString().includes(sessionStorage.getItem("ORDER_ID"))
    );
    try {
      const req = new Request();

      const body = {
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        EVENT_ID: order[0].storeId,
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT") || "",
        DELIVER_ID: sessionStorage.getItem("DELIVER_ID"),
        ORDER_ID: order[0].orderId,
      };

      req.body = body;

      req.route = "getDeliveryTime";
      req.callbackSuccess = (response: any) => {
        const estimatedTimes = this.items
          .map((item: any) => item?.estimatedTime)
          .filter(
            (time: number | null | undefined) => time != null && time > 0
          );

        const maxEstimatedTime =
          estimatedTimes.length > 0 ? Math.max(...estimatedTimes) : 0;

        this.minDeliveryTime = response.data.MIN_DELIVERY_TIME ?? null;
        if (response.data.MAX_DELIVERY_TIME === null) {
          this.maxDeliveryTime = null;
        } else {
          this.maxDeliveryTime = Math.max(
            response.data.MAX_DELIVERY_TIME,
            maxEstimatedTime || 0
          );
        }
      };
      req.callbackError = (error: any) => {
        console.error(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (error) {
      console.error(error);
    }
  }

  displayTimeWithIncrement(increment: number) {
    if (this.createdDate && this.createdDate.date) {
      return moment(this.formatDateTime(this.createdDate.date, true))
        .add(increment, "minutes")
        .format("HH:mm");
    }
  }

  isPickupDay(scheduledDateTime: string): boolean {
    if (!scheduledDateTime) return false;

    const datePart = scheduledDateTime.split(" ")[0];
    const [year, month, day] = datePart.split("-").map(Number);
    const scheduledDate = new Date(year, month - 1, day, 12, 0, 0); // Define horário para 12:00

    const today = new Date();

    return (
      scheduledDate.getFullYear() === today.getFullYear() &&
      scheduledDate.getMonth() === today.getMonth() &&
      scheduledDate.getDate() === today.getDate()
    );
  }

  selectStore() {
    const storeId = this.orderData.storeId;

    sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(false));
    sessionStorage.removeItem("STRUCTURE_ID");
    sessionStorage.removeItem("CLICK_PRODUCT");
    if (sessionStorage.getItem("STORE")) {
      sessionStorage.removeItem("STORE");
      sessionStorage.removeItem("CURRENT_ORDER");
      sessionStorage.removeItem("ITEMS");
      sessionStorage.removeItem("DELIVERY_DATA");
    }
    if (!sessionStorage.getItem("CAME_FROM_RELEASE")) {
      sessionStorage.removeItem("DELIVER_AT");
      sessionStorage.removeItem("deliversToTable");
      sessionStorage.removeItem("deliversToBalcony");
      sessionStorage.removeItem("deliversToAddress");
      sessionStorage.removeItem("deliversToInternalLocation");
    }
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    sessionStorage.setItem("GO_TO_STORE", "true");
    if (
      sessionStorage.getItem("CURRENT_ORDER") &&
      storeId.toString() != sessionStorage.getItem("storeId")
    ) {
      sessionStorage.setItem("CURRENT_ORDER", "{}");
    }
    sessionStorage.setItem("storeId", storeId.toString());

    this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
      if (response) {
        sessionStorage.getItem("STORE")
          ? this.$router.push("Produtos")
          : this.goProducts();
      } else {
        sessionStorage.getItem("STORE")
          ? this.$router.push("ListaDeProdutos")
          : this.goProducts("ListaDeProdutos");
      }
    });
  }

  async getIfStoreHasAnySubmenu(storeId: number) {
    const request = new Request();
    request.route = `getIfStoreHasAnySubmenu?requestType=FilterData&STORE_ID=${storeId}`;
    request.showLoader = false;
    try {
      const response = await request.get();
      return response.ifStoreHasAnySubmenu.ifHasSubmenu;
    } catch (error) {
      console.error(error);
    }
  }

  goProducts(path = "Produtos") {
    sessionStorage.setItem("loadStore", JSON.stringify(true));
    this.$router.push(path);
  }

  mostraModal(messageTop: string, message: string) {
    this.modalMessageTop = messageTop;
    this.modalMessage = message;
    this.showModal = true;
  }

  fechaModal() {
    this.showModal = false;
  }

  goToSurveys(orderId: any) {
    sessionStorage.setItem("ORDER_ID", orderId + "");
    this.$router.push("Surveys");
  }

  calculatePriceFromExtras(extras: any[], onlyRequired = false): number {
    let total = 0;

    for (const extra of extras) {
      if (onlyRequired && !extra.required) {
        continue;
      }

      if (extra.selectedOptions && extra.selectedOptions.length > 0) {
        for (const option of extra.selectedOptions) {
          total += parseFloat(option.price) * option.quantity;
        }
      }
    }

    return total;
  }

  async addToCart(order: any) {
    const products: any = await this.getStoreAndProductsData(
      order.storeId,
      order.bodySaveOrder
    );

    if (products) {
      if (sessionStorage.getItem("STORE")) {
        sessionStorage.removeItem("STORE");
        sessionStorage.removeItem("CURRENT_ORDER");
        sessionStorage.removeItem("ITEMS");
        sessionStorage.removeItem("DELIVERY_DATA");
      }

      this.currentOrder = {
        DELIVER_TO: order.deliverTo,
        STORE_ID: order.storeId,
        DISCOUNT: 0,
        CUPOM_ID: null,
        TOTAL_VALUE: 0,
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        ORDER_ITEMS: [],
        STRUCTURE_ID: null,
        STRUCTURE_NAME: null,
        AMOUNT_OF_ITEMS: 0,
      };

      let amountOfItems = 0;

      const items = products.map((product: any, index: number) => {
        const addItem = order.bodySaveOrder.find(
          (item: any) => item.productId == product.id
        );

        if (
          parseInt(addItem.quant) == product.amount &&
          product.blockOrderWithNoStock
        ) {
          product.disabledBtnAdd = true;
        } else {
          product.disabledBtnAdd = false;
        }

        let idProd = addItem.productId;
        if (addItem.type == "pizza")
          idProd = idProd + "." + addItem.extras[0].limitQuantityMin;

        const quant = parseInt(addItem.quant, 10);

        let basePrice = product.price || addItem.basePrice;

        let extrasTotal = 0;

        if (addItem.extras && addItem.extras.length) {
          addItem.extras.forEach((extra: any) => {
            if (extra.selectedOptions && extra.selectedOptions.length) {
              extra.selectedOptions.forEach((option: any) => {
                const optionPrice = Number(option.price) || 0;
                const optionQuantity = Number(option.quantity) || 1;
                extrasTotal += optionPrice * optionQuantity;
              });
            }
          });
        }

        let priceUnitTotal = basePrice + extrasTotal;
        let price = priceUnitTotal * quant;

        // mantém regra especial de combo
        if (addItem.type === "combo") {
          basePrice = this.calculatePriceFromExtras(addItem.extras, true);
          priceUnitTotal = this.calculatePriceFromExtras(addItem.extras, false);
          price = priceUnitTotal * quant;
        }

        const item = {
          quant: quant,
          productName: addItem.productName,
          itemId: index,
          note: "",
          extras: addItem.extras,
          productId: idProd,
          estimatedTime: product.estimatedTime,
          price: price,
          priceUnitTotal: priceUnitTotal,
          basePrice: basePrice,
          menuId: product.menuId,
          externalId: product.originalProduct.externalId,
          disabledBtnAdd: product.disabledBtnAdd,
          productAmount: product.amount,
          blockOrderWithNoStock: product.blockOrderWithNoStock,
          type: addItem.type ? addItem.type : "default",
        };

        amountOfItems += item.quant;

        if (window.dataLayer) {
          GoogleTagManagerService.pushDataLayer({
            event: "add_to_cart",
            items: [
              {
                item_id: item.productId,
                item_name: item.productName,
                item_category: product.productGroupId || "",
                quantity: item.quant,
                price: item.priceUnitTotal,
              },
            ],
          });
        }

        return item;
      });

      this.currentOrder.ORDER_ITEMS = items;
      this.currentOrder.TOTAL_VALUE = this.calcTotalPrice();
      this.currentOrder.AMOUNT_OF_ITEMS = amountOfItems;

      sessionStorage.setItem(
        "CURRENT_ORDER",
        JSON.stringify(this.currentOrder)
      );
      sessionStorage.setItem("ITEMS", JSON.stringify(this.currentOrder));
      sessionStorage.setItem("DELIVER_AT", order.deliverTo);

      this.goToStore(order.storeId);
    }
  }

  calcTotalPrice() {
    let totalPrice = 0;
    if (this.currentOrder.ORDER_ITEMS.length > 0) {
      this.currentOrder.ORDER_ITEMS.forEach((item: any) => {
        totalPrice += item.priceUnitTotal * item.quant;
        item.price = item.priceUnitTotal * item.quant;
      });
    }
    if (this.currentOrder.DISCOUNT > 0)
      return totalPrice - this.currentOrder.DISCOUNT;
    return totalPrice;
  }

  getDeviceTime() {
    moment.locale("pt-br");
    const deviceTime: any = moment().format("LT");
    return deviceTime;
  }

  getStoreAndProductsData(storeId: number, items: any) {
    return new Promise((resolve, reject) => {
      const req = new Request();
      req.route = "getStoreData";
      req.showLoader = true;
      req.body = {
        STORE_ID: storeId,
        ALL_MENUS: "NO",
        DELIVER_AT: "",
        DEVICE_TIME: this.getDeviceTime(),
      };

      req.callbackSuccess = async (response: any) => {
        const store = response.store;
        const storeIsOpen = store.opened;

        if (!storeIsOpen) {
          this.mostraModal(
            "Esta loja está fechada no momento.",
            "Tente adicionar os produtos ao carrinho mais tarde, quando a loja estiver aberta. Você ainda pode acessar o cardápio à vontade."
          );
          resolve(false);
          return;
        }

        const allProductGroups = store.menus.currentWorkshift.flatMap(
          (menu: any) => menu.productGroups
        );

        const validationResults = await Promise.all(
          items.map(async (orderedItem: any) => {
            if (orderedItem.type === "pizza") {
              const flavorExtra = orderedItem.extras.find(
                (extra: any) => extra.name === "Sabor"
              );
              if (!flavorExtra || !flavorExtra.selectedOptions.length)
                return null;

              const firstFlavorId = flavorExtra.selectedOptions[0].id;

              let pizzaProductGroup: any = null;
              for (const group of allProductGroups) {
                if (group.products.some((p: any) => p.id == firstFlavorId)) {
                  pizzaProductGroup = group;
                  break;
                }
              }

              if (!pizzaProductGroup || pizzaProductGroup.type !== "pizza")
                return null;

              const sizeIsValid = pizzaProductGroup.productGroupPizzaSize.some(
                (size: any) => size.id == orderedItem.productId && size.status
              );
              if (!sizeIsValid) return null;

              for (const selectedFlavor of flavorExtra.selectedOptions) {
                const flavorInMenu = pizzaProductGroup.products.find(
                  (p: any) => p.id == selectedFlavor.id
                );

                if (!flavorInMenu || flavorInMenu.status !== "A") return null;

                if (
                  flavorInMenu.blockOrderWithNoStock &&
                  (flavorInMenu.amount === 0 ||
                    parseFloat(orderedItem.quant) > flavorInMenu.amount)
                ) {
                  return null;
                }
              }

              for (const orderedExtra of orderedItem.extras) {
                if (orderedExtra.name === "Sabor") continue;

                let sourceArray: any[] = [];
                if (orderedExtra.name === "Massa") {
                  sourceArray = pizzaProductGroup.productGroupPizzaCrusts;
                } else if (orderedExtra.name === "Borda") {
                  sourceArray = pizzaProductGroup.productGroupPizzaEdges;
                }

                if (sourceArray.length > 0) {
                  for (const selectedOption of orderedExtra.selectedOptions) {
                    const optionExists = sourceArray.some(
                      (opt: any) =>
                        opt.id == selectedOption.id &&
                        (opt.status === undefined || opt.status === true)
                    );
                    if (!optionExists) return null;
                  }
                }
              }

              const pizzaSizeDetails =
                pizzaProductGroup.productGroupPizzaSize.find(
                  (s: any) => s.id == orderedItem.productId
                );
              return {
                id: orderedItem.productId,
                name: orderedItem.productName,
                type: "pizza",
                price: orderedItem.priceUnitTotal,
                amount: 1,
                blockOrderWithNoStock: false,
                originalProduct: { externalId: pizzaSizeDetails.externalId },
                menuId: pizzaProductGroup.products[0]?.menuId,
              };
            } else {
              let productInMenu: any = null;
              for (const group of allProductGroups) {
                const found = group.products.find(
                  (p: any) => p.id == orderedItem.productId
                );
                if (found) {
                  productInMenu = found;
                  break;
                }
              }

              if (!productInMenu) return null;

              if (
                productInMenu.blockOrderWithNoStock &&
                (productInMenu.amount === 0 ||
                  parseFloat(orderedItem.quantity) > productInMenu.amount)
              ) {
                return null;
              }

              await this.verifyGetExtras(productInMenu, storeId);
              if (orderedItem.extras && orderedItem.extras.length > 0) {
                for (const orderedExtra of orderedItem.extras) {
                  const menuExtra = productInMenu.extras.find(
                    (extra: any) => extra.id === orderedExtra.id
                  );
                  if (!menuExtra) return null;

                  for (const selectedOption of orderedExtra.selectedOptions) {
                    if (
                      !menuExtra.options.some(
                        (option: any) => option.id === selectedOption.id
                      )
                    ) {
                      return null;
                    }
                  }
                }
              }

              return {
                ...productInMenu,
                price: productInMenu.price,
                originalProduct: { externalId: productInMenu.externalId },
              };
            }
          })
        );

        const validProducts = validationResults.filter((p) => p !== null);

        const allItemsAvailable = items.length === validProducts.length;

        if (!allItemsAvailable) {
          this.mostraModal(
            "Itens do pedido indisponíveis.",
            "Alguns itens desta compra estão indisponíveis no momento, seja por falta de estoque, extras ou restrições de horário. Você pode tentar novamente mais tarde ou acessar o cardápio da loja para adicionar os produtos disponíveis."
          );
          resolve(false);
        } else {
          resolve(validProducts);
        }
      };

      req.callbackError = (error: any) => {
        console.error(error);
        reject(false);
      };

      req.send();
    });
  }

  verifyGetExtras(product: any, storeId: number) {
    return new Promise((resolve, reject) => {
      const req = new Request();
      req.route = "getExtras";
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        EVENT_ID: storeId,
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        PRODUCT_ID: product.id,
      };
      req.callbackSuccess = (response: any) => {
        product.extras = response.extras;
        resolve(true);
      };
      req.callbackError = (error: any) => {
        console.error(error);
        reject(false);
      };
      req.send();
    });
  }

  goToStore(storeId: number) {
    sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(false));
    sessionStorage.removeItem("STRUCTURE_ID");
    sessionStorage.removeItem("CLICK_PRODUCT");
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    sessionStorage.setItem("GO_TO_STORE", "true");

    this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
      if (response) {
        sessionStorage.getItem("STORE")
          ? this.$router.push("Produtos")
          : this.goProducts();
      } else {
        sessionStorage.getItem("STORE")
          ? this.$router.push("ListaDeProdutos")
          : this.goProducts("ListaDeProdutos");
      }
    });
  }

  openModalCancelOrder() {
    this.modalMessageTop = "Tem certeza que deseja cancelar o pedido?";
    this.modalMessage =
      "Ao confirmar, seu pedido será cancelado. Se precisar de assistência, entre em contato com a loja.";
    this.showModalCancelOrder = true;
  }
}
